var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"closeDiv"},[_c('v-btn',{staticClass:"breadcrumbBackground closeBtn",attrs:{"icon":"","fab":"","width":"35px","height":"35px"}},[_c('v-icon',{attrs:{"color":"firstColor"}},[_vm._v(" mdi-close ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }